import chalk from "chalk";


export const logDebug = (...args: any[]) => {
   if (process.env.NODE_ENV === "development") console.log(chalk.blue("DEBUG"), ...args );
};

export const logError = (code : string, ...args: any[]) => {
   if (process.env.NODE_ENV === "development") console.log(chalk.red(code), ...args); 
};

export const truncate = (str: string, maxLength: number) => {
  if (str.length <= maxLength) return str;
  return str.substring(0, maxLength - 3) + "...";
};